import { InjectionToken } from '@angular/core';
import { Leerkr8PlaythroughRequest, Leerkr8PlaythroughResponse } from '@core/saves/leerkr8/types';
import { ISaveState } from '@core/saves/saves.interface';
import { Observable } from 'rxjs';

export const LEERKR8_API_SERVICE = new InjectionToken<ILeerkr8ApiService>('Leerkr8ApiService');

export interface ILeerkr8ApiService {
  startSession(playerCode: string): Observable<{
    sessionId: string;
    playerCode: string;
    localeId: string;
    properties: Record<string, string>;
  }>;
  getGameSave(sessionId: string, playerCode: string): Promise<ISaveState>;
  setGameSave(sessionId: string, playerCode: string, save: ISaveState): Observable<any>;
  activateDevice(
    activationCode: string,
    deviceIdentifier: string,
    deviceName: string,
  ): Observable<{
    instituteName: string;
    token: string;
  }>;
  getPlayerGroup(
    deviceToken: string,
    deviceIdentifier: string,
    playerGroupCode: string,
  ): Observable<{
    playerCodes: string[];
    playerSaves: {
      properties: Record<string, string>;
      nickname: string;
      fullName: string;
      localeId: string;
    }[];
    skipParentalGuard: boolean;
  }>;
  postPlaythrough(sessionId: string, playerCode: string, playthrough: Leerkr8PlaythroughRequest): Observable<Leerkr8PlaythroughResponse>;
}
